import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import {
    CCard, CCardBody, CCardHeader, CCol, CRow, CLink, CButton, CButtonGroup, CSpinner,
    CContainer, CForm, CFormGroup, CLabel, CInput, CFormText, CSelect, CInputCheckbox,
    CModal,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import styles from "../styles/style.module.css";
const axios = require("axios");

export class MasterDeviceCreate extends Component {
    static displayName = MasterDeviceCreate.name;

    constructor(props) {
        super(props);


        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            userName: null,
            loading: false,
            sysid: "00000000-0000-0000-0000-000000000000",
            title: "",
            description: "",
            serialno: "",
            devicetoken: "",
            model: "AR_L3",
            siteid: "00000000-0000-0000-0000-000000000000",
            sitemodels: [],
            modalState: false,
            modalTitle: "",
            modalMessage: ""
        };
    }



    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();

        this.populateData();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }


    async populateData() {
        const token = await authService.getAccessToken();
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }

        axios.get("api/sites/getall", {
            headers: headers
        })
            .then((responsesite) => {
                this.setState({
                    sitemodels: responsesite.data
                });

            })
            .catch((errorsite) => {

            });
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        this.setState({
            isAuthenticated,
            userName: user && user.name
        });
    }


    async onSubmit(e) {

        e.preventDefault();

        const token = await authService.getAccessToken();
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }

        const data = {
            sysid: this.state.sysid,
            title: this.state.title,
            description: this.state.description,
            serialno: this.state.serialno,
            devicetoken: this.state.devicetoken,
            model: this.state.model,
            siteid: this.state.siteid
        };

        console.log(data);

        debugger;

        axios.post('api/masterdevices/post', data, {
            headers: headers
        })
            .then((response) => {
                debugger;
                console.log(response.data);

                if (response.data.status) {
                    this.props.history.push('/master/devices');
                } else {
                    this.setState(
                        (state) => ({
                            modalTitle: response.data.result,
                            modalMessage: response.data.message
                        }),
                        () => {
                            this.setState(
                                (state) => ({
                                    modalState: true,
                                }),
                                () => {

                                }
                            );
                        }
                    );

                }
            })
            .catch((error) => {
                debugger;
                console.log(error);
            })


    }

    render() {

        const { sitemodels, modalState, modalTitle, modalMessage } = this.state;
        return (
            <>
                <CCard>
                    <CCardHeader
                    color="success"
                    >
                        <h4 id="traffic" className="card-title mb-0">
                            Add Master Device
                        </h4>
                    </CCardHeader>
                    <CCardBody>
                        <CContainer fluid>


                            <CForm id="main"
                                onSubmit={this.onSubmit}
                                className="row g-3" autoComplete="off">
                                <CCol md={12}>
                                    <CLabel htmlFor="title">Title</CLabel>
                                    <CInput type="text" id="title" name="title" placeholder="" autoComplete="off" value={this.state.title}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            this.setState(
                                                (state) => ({
                                                    title: value,
                                                }),
                                                () => {

                                                }
                                            );
                                        }}
                                        required />
                                </CCol>
                                <CCol md={4}>
                                    <CLabel htmlFor="model">Model</CLabel>
                                    <CSelect id="model" name="model" value={this.state.model}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            this.setState(
                                                (state) => ({
                                                    model: value,
                                                }),
                                                () => {

                                                }
                                            );
                                        }}
                                    >
                                        <option value="AR_L3">AR L3</option>
                                    </CSelect>
                                </CCol>
                                <CCol md={4}>
                                    <CLabel htmlFor="serialno">Serial No. (Serial Number ด้านหลังกล่อง (ตัวอย่าง: ARLXXXXX))</CLabel>
                                    <CInput id="serialno" name="serialno" placeholder="" autoComplete="off" value={this.state.serialno}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            this.setState(
                                                (state) => ({
                                                    serialno: value.replace(/\s/g, '').toUpperCase(),
                                                }),
                                                () => {

                                                }
                                            );
                                        }}
                                        required maxLength="20" />
                                </CCol>
                                <CCol md={4}>
                                    <CLabel htmlFor="devicetoken">Device Token (Device Token ด้านหลังกล่อง (ตัวอย่าง: XXXXXX9999YY777))</CLabel>
                                    <CInput id="devicetoken" name="devicetoken" placeholder="" autoComplete="off" value={this.state.devicetoken}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            this.setState(
                                                (state) => ({
                                                    devicetoken: value.replace(/\s/g, '').toUpperCase(),
                                                }),
                                                () => {

                                                }
                                            );
                                        }}
                                        required maxLength="20" />
                                </CCol>
                                <CCol xs={12}>
                                    <CButton type="submit" className="btn btn-outline-primary">Submit</CButton>
                                    <CButton type="button" className="btn btn-outline-light ml-2" onClick={(e) => { this.props.history.push('/master/devices'); }}>Cancel</CButton>
                                </CCol>
                            </CForm>
                        </CContainer>
                    </CCardBody>
                </CCard>

                <CModal
                    show={modalState}
                    onClick={(e) => {
                        this.setState((state) => ({
                            modalState: false,
                        }));
                    }}
                >
                    <CModalHeader closeButton>
                        <CModalTitle>{modalTitle}</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        {modalMessage}
                    </CModalBody>
                    <CModalFooter>
                        <CButton
                            color="primary"
                            onClick={(e) => {
                                this.setState((state) => ({
                                    modalState: false,
                                }));
                            }}
                        >
                            OK
                        </CButton>
                    </CModalFooter>
                </CModal>
            </>
        );
    }
}